import { MainLayout } from 'components';
import React, { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import {
  Col,
  Form,
  Input,
  Row,
  Space,
  Table,
  DatePicker,
  Select,
  Typography,
} from 'antd';
import Button from 'components/Button';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import useQueryParam from 'hooks/useQueryPrams';
import {
  AddIcon,
  Cart,
  EditIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
} from 'assets/svg';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';
import { useHistory } from 'react-router-dom';
import { IGetUserQuery } from 'interface/user.interface';
import { HocChangePagination } from 'utils/HocChangePagination';
import CartApi from 'apis/CartApi';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { useMutation, useQuery } from 'react-query';
import moment from 'moment';
import { useUser } from 'contexts/User';
import { CART_REG_STATUS } from 'constants/statusCartPage';
import { PRODUCT_POF_STATUS } from 'constants/productStatus';
import { useForm } from 'antd/es/form/Form';

type FixedType = 'left' | 'right' | boolean;
const { Text } = Typography;

export default function PreOrderListPage() {
  const history = useHistory();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [ellipsis, setEllipsis] = useState(true);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const { user } = useUser();
  const { Option } = Select;
  const [form] = useForm();

  const { RangePicker } = DatePicker;
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const params = {
    page: page,
    page_size: page_size,
    ...(formSubmitParams && formSubmitParams),
  };

  const {
    mutate: getCartChiNhanh,
    data: lstCartData,
    isLoading: getCartsLoading,
  } = useMutation(['getCartChiNhanh'], () =>
    CartApi.getCartChiNhanh(user?.plantId ?? 0, params)
  );

  useEffect(() => {
    setTitle('Đăng ký mẫu');
    setBreadcrumb([
      { title: <a href="">Giỏ hàng</a> },
      { title: <a href="/preorder">Đăng ký mẫu</a> },
    ]);
    // Chi nhánh đăng kí mẫu
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
    if (user) {
      getCartChiNhanh();
    }
  }, [user, page, page_size, formSubmitParams]);

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã giỏ hàng',
      dataIndex: 'cart_code',
      width: 160,
    },
    {
      title: 'Loại giỏ hàng',
      dataIndex: 'cart_type_name',
      width: 180,
    },
    {
      title: 'Tên giỏ hàng',
      // dataIndex: 'cart_name',
      width: 250,
      render: (_: any, record: any) => (
        <Text ellipsis={ellipsis ? { tooltip: record.cart_name } : false}>
          {record.cart_name}
        </Text>
      ),
    },
    {
      title: 'Trạng thái giỏ hàng hội sở',
      dataIndex: '',
      width: 220,
      render: (_: any, record: any) => {
        return convertStatusHoiSo(record?.status);
      },
    },
    {
      title: 'Trạng thái đăng ký',
      dataIndex: '',
      width: 160,
      render: (_: any, record: any) => {
        return convertStatusRegister(record?.status);
      },
    },
    {
      title: 'Số mẫu đăng ký',
      dataIndex: 'template_counter',
      width: 160,
    },
    // {
    //   title: 'Mã cửa hàng',
    //   dataIndex: 'plant_code',
    //   width: 160,
    // },
    // {
    //   title: 'Ngành hàng',
    //   width: 250,
    //   render: (_: any, record: any) => (
    //     <Text ellipsis={ellipsis ? { tooltip: record.nganh_hang } : false}>
    //       {(record.nganh_hang ? record.nganh_hang : []).join(', ')}
    //     </Text>
    //   ),
    // },
    // {
    //   title: 'Nhãn hàng',
    //   width: 250,
    //   render: (_: any, record: any) => (
    //     <Text ellipsis={ellipsis ? { tooltip: record.nhan_hang } : false}>
    //       {(record.nhan_hang ? record.nhan_hang : []).join(', ')}
    //     </Text>
    //   ),
    // },
    {
      title: 'Dòng hàng',
      width: 250,
      render: (_: any, record: any) => (
        <Text ellipsis={ellipsis ? { tooltip: record.dong_hang } : false}>
          {(record.dong_hang ? record.dong_hang : []).join(', ')}
        </Text>
      ),
    },
    // {
    //   title: 'Chủng loại',
    //   width: 250,
    //   render: (_: any, record: any) => (
    //     <Text ellipsis={ellipsis ? { tooltip: record.chung_loai } : false}>
    //       {(record.chung_loai ? record.chung_loai : []).join(', ')}
    //     </Text>
    //   ),
    // },
    {
      title: 'Người khai báo',
      dataIndex: 'created_by',
      width: 180,
    },
    {
      title: 'Phòng ban',
      dataIndex: 'department_name',
      width: 300,
    },
    {
      title: 'Đơn vị phát hành',
      dataIndex: 'division',
      width: 300,
    },
    {
      title: 'Công ty phát hành',
      // dataIndex: 'company',
      width: 250,
      render: (_: any, record: any) => {
        return record?.company == null ? '-' : record?.company;
      },
    },
    {
      title: 'Đặt hàng theo ni',
      // dataIndex: 'order_ni',
      width: 150,
      render: (_: any, record: any) => {
        return record?.order_ni == true ? 'Có' : 'Không';
      },
    },
    {
      title: 'Ngày phát hành',
      dataIndex: 'release_date',
      width: 150,
      render: (release_date) => {
        return moment(release_date).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Ngày hết hạn',
      dataIndex: 'expiration_date',
      width: 150,
      render: (expiration_date) => {
        return moment(expiration_date).format('DD/MM/YYYY');
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      width: 120,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          {/* <button
            onClick={() => {
              history.push(`/preorder/edit/${record?.plant_id}/${record?.id}`);
            }}
          >
            <EyeIcon />
          </button> */}
          <button
            onClick={() => {
              history.push('/preorder-create-order', {
                cart: record,
              });
            }}
          >
            <Cart />
          </button>
        </div>
      ),
    },
  ];

  const convertStatusHoiSo = (status: number) => {
    switch (status) {
      case 0:
        return 'Đã phát hành';
      case 1:
        return 'Hết hạn';
      case 2:
        return 'Vô hiệu hóa';
      default:
        return '-';
    }
  };

  const convertStatusRegister = (status: number) => {
    switch (status) {
      case 0:
        return 'Mới';
      case 1:
        return 'Đã đăng ký';
      case 2:
        return 'Chưa đăng ký';
      default:
        return '-';
    }
  };

  const handleEditDetailCart = (id: number) => {
    history.push(`/preorder/edit`);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(
        ([_, value]) =>
          value !== undefined && !(Array.isArray(value) && value.length === 0)
      )
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (key == 'releaseDate') {
        if (filteredData[key] != null) {
          const ranges: any = filteredData[key];
          stringifiedData['release_from'] = ranges[0].format('YYYY/MM/DD');
          stringifiedData['release_to'] = ranges[1].format('YYYY/MM/DD');
        }
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });

    setFormSubmitParams(stringifiedData);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  return (
    <MainLayout>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
        <Col span={12} className="flex justify-end">
          <Space>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        form={form}
        layout="vertical"
        className={` ${isOpenFilter ? '' : 'hidden'} mt-4`}
        onFinish={onFinish}
        autoComplete="off"
        size="small"
      >
        <Content style={{ paddingTop: '10px', paddingBottom: '10px' }}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="cart_code" label="Mã giỏ hàng">
                <Input placeholder="Nhập mã giỏ hàng" className="" />
              </Form.Item>
            </Col>

            <Col className="" span={8}>
              <Form.Item name="cart_name" label="Tên giỏ hàng">
                <Input placeholder="Nhập tên giỏ hàng" className="" />
              </Form.Item>
            </Col>

            <Col className="" span={8}>
              <Form.Item name="cart_type" label="Loại giỏ hàng">
                <Select
                  placeholder="Loại giỏ hàng"
                  className="w-full"
                  allowClear
                  // value={bstSelected}
                  // onChange={(value) => {
                  //   setBST(value);
                  //   changeSelect();
                  // }}
                >
                  {PRODUCT_POF_STATUS.map((item) => (
                    <Option
                      value={item.value}
                      key={item.label}
                      defaultValue={''}
                    >
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="status" label="Trạng thái đăng ký">
                <Select
                  placeholder="Trạng thái đăng ký"
                  className="w-full"
                  allowClear
                  // value={bstSelected}
                  // onChange={(value) => {
                  //   setBST(value);
                  //   changeSelect();
                  // }}
                >
                  {CART_REG_STATUS.map((item) => (
                    <Option
                      value={item.values}
                      key={item.label}
                      defaultValue={''}
                    >
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="releaseDate" label="Ngày phát hành">
                <RangePicker
                  placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                  format={'DD/MM/YYYY'}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          dataSource={lstCartData?.data}
          scroll={{ x: 958 }}
          loading={getCartsLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: lstCartData?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
